import type { ControlListItem } from "@/models/control.model";
import { Button } from "@spz/ui/components/button";
import type { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const ControlListResetFiltersButton = ({
  table,
}: { table: Table<ControlListItem> }) => {
  const { t } = useTranslation();

  const hasFilters =
    table.getState().columnFilters.length > 0 || table.getState().globalFilter;

  if (!hasFilters) return null;

  return (
    <Button
      variant="ghost"
      leftIcon="x"
      onClick={() => {
        table.resetColumnFilters();
        table.resetGlobalFilter();
      }}
      data-testid="filter-clear-button"
    >
      {t("clear_filters")}
    </Button>
  );
};
